import { useState } from "react";
import { Sparkles, Monitor, Smartphone, Code2, Eye } from "lucide-react";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";
import { Cost, CopyButton, PageHeader, Section, Spinner } from "../components/AiHtml";
import { useGenerate } from "../lib/useGenerate";

const Toggle = ({ on, onClick, icon: Icon, label, testId }) => (
  <button data-testid={testId} onClick={onClick} className={`pill inline-flex items-center gap-1.5 ${on ? "pill-on" : "pill-off"}`}><Icon size={13} /> {label}</button>
);

export default function EmailStudio() {
  const [prompt, setPrompt] = useState("");
  const [device, setDevice] = useState("desktop");
  const [view, setView] = useState("preview");
  const g = useGenerate("email");
  const r = g.result;
  return (
    <div className="space-y-6">
      <PageHeader label="Email Studio" title="Responsive HTML emails" desc="Generate table-based, inline-styled emails that work in Gmail and Outlook." />
      <div className="card-n p-5 space-y-4">
        <Textarea data-testid="email-prompt-input" rows={3} value={prompt} onChange={(e) => setPrompt(e.target.value)} placeholder="e.g. Diwali sale email, 30% off, for a jewellery brand" />
        <div className="flex items-center gap-3"><Cost n={8} /><Button data-testid="email-generate-btn" disabled={g.busy || !prompt.trim()} onClick={() => g.run(prompt)} className="rounded-full"><Sparkles size={16} className="mr-1.5" /> Generate email</Button></div>
      </div>
      {g.busy && <div className="card-n"><Spinner label="Designing your email..." /></div>}
      {!g.busy && r && (
        <Section title={`Subject: ${r.subject}`} testId="email-result" right={<CopyButton testId="email-copy-code-btn" text={r.html} label="Copy HTML" />}>
          <p className="text-xs text-slate-500 mb-4">Preheader: {r.preheader}</p>
          <div className="flex flex-wrap gap-2 mb-4">
            <Toggle testId="email-view-preview" on={view === "preview"} onClick={() => setView("preview")} icon={Eye} label="Preview" />
            <Toggle testId="email-view-code" on={view === "code"} onClick={() => setView("code")} icon={Code2} label="Code" />
            <span className="w-px bg-slate-800 mx-1" />
            <Toggle testId="email-device-desktop" on={device === "desktop"} onClick={() => setDevice("desktop")} icon={Monitor} label="Desktop" />
            <Toggle testId="email-device-mobile" on={device === "mobile"} onClick={() => setDevice("mobile")} icon={Smartphone} label="Mobile" />
          </div>
          {view === "preview" ? (
            <div className="bg-slate-200 rounded-xl p-4 flex justify-center">
              <iframe data-testid="email-preview-frame" title="email" srcDoc={r.html} className="bg-white rounded-lg transition-[width] duration-300 h-[640px]" style={{ width: device === "mobile" ? 375 : "100%", maxWidth: 720 }} />
            </div>
          ) : (
            <pre data-testid="email-code-view" className="text-xs bg-[#070B14] p-4 rounded-lg overflow-auto max-h-[640px] scroll-thin text-slate-300">{r.html}</pre>
          )}
        </Section>
      )}
    </div>
  );
}
